var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"checkWrapper"},[_c('b-icon',{staticClass:"checkIcon",attrs:{"icon":"check"}})],1),_c('h1',[_vm._v("Zahlung erhalten")]),_c('p',[_vm._v("Wir haben deine Zahlung erhalten")])])}
var staticRenderFns = []

export { render, staticRenderFns }